/** Looks up an element declared in index.html. Throws if the page markup is out of sync. */
export function requireElement<T extends HTMLElement>(id: string): T {
  const found = document.getElementById(id);
  if (!found) throw new Error(`Missing element #${id}`);
  return found as T;
}
